import React from 'react';
import PropTypes from 'prop-types';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Typography, CircularProgress
} from '@mui/material';
import RTL from '../../../utils/RTL';

const ConfirmationDialog = ({
    open,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = 'ثبت',
    cancelText = 'برگشت',
    confirmColor = 'primary',
    isLoading = false,
}) => {
    return (
        <RTL>
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="confirmation-dialog-title"
                sx={{ direction: 'rtl' }}
            >
                <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    <Typography>{message}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={onClose}
                        color="primary"
                        disabled={isLoading}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        onClick={onConfirm}
                        color={confirmColor}
                        variant="contained"
                        disabled={isLoading}
                        startIcon={isLoading ? <CircularProgress size={20} /> : null}
                    >
                        {confirmText}
                    </Button>
                </DialogActions>
            </Dialog>
        </RTL>
    );
};

ConfirmationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    confirmColor: PropTypes.oneOf(['primary', 'error', 'success', 'warning']),
    isLoading: PropTypes.bool,
};

ConfirmationDialog.defaultProps = {
    confirmText: 'ثبت',
    cancelText: 'برگشت',
    confirmColor: 'primary',
    isLoading: false,
};

export default ConfirmationDialog;